/* eslint-disable import/prefer-default-export */
import styledLib, { css } from 'styled-components';

const DEFAULT_FONT_SIZE = '20px';
const DEFAULT_BORDER_RADIUS = '4px';
const DEFAULT_MARGIN = '10px 0 0 0';

export const StyledButton = styledLib.button`${(props) => {
  const {
    styled, reverse, truncate, submit,
  } = props;
  const {
    backgroundColor,
    borderRadius,
    color,
    fontSize,
    hover,
    margin,
    maxHeight,
  } = styled;
  const fs = fontSize || DEFAULT_FONT_SIZE;
  const br = borderRadius || DEFAULT_BORDER_RADIUS;
  const mg = margin || DEFAULT_MARGIN;

  if (reverse) {
    return css`
    && {
      border: 1px solid ${backgroundColor};
      max-height: ${maxHeight};
      white-space: pre-wrap;
      color: ${backgroundColor};
      font-size: ${fs};
      background-color: ${color};
      padding-top: 15px;

      &:hover,
      &:focus{
        background-color: ${backgroundColor};
        color: ${color};
        background-image: initial !important;
        box-shadow: ${hover.boxShadow};
      }
    }`;
  }

  return css`
    && {
      border: 1px solid transparent;
      max-height: ${maxHeight};
      border-radius: ${br};
      white-space: pre-wrap;
      color: ${color};
      font-size: ${fs};
      background-color: ${backgroundColor};
      opacity: unset;
      margin: ${mg};

      &:hover {
        background-color: ${hover.backgroundColor};  
        background-image: initial !important;
        box-shadow: ${hover.boxShadow};
        color: ${hover.color};
      }
      
      ${truncate && `{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; 
      }`}

      ${submit && `{
        display: inline-flex;
        width: 100%;
        min-height: 40px;
        justify-content: center;
        align-items: center;
        line-height: ${fs};
        font-weight: bold;
        padding: 10px;
        border-radius: ${br};
      }`}
    }`;
}}`;
